<template>
    <div class="todo-list-page-list">
        <div
            v-for="(item, index) in data"
            :key="index"
            class="todo-list-item"
            @click="handleClick(item)"
        >
            <p>{{ item.title || "未命名" }}</p>
            <div class="todo-list-sub-info">
                <span>发起人: {{ item.userName }} </span>
                <span>发起时间:  {{ item.dateTime }}</span>
            </div>
            <div class="todo-list-item-footer">
                <!-- <span class="success"> 招标公告 </span> -->
                <span :class="getStatusClass(item)"> {{ getStatusText(item) }} </span>
            </div>
            <span class="todo-list-item-btn"> 审批 <van-icon name="arrow" /> </span>
        </div>
    </div>
</template>

<script>
    const {
        getStatusText,
        getStatusClass,
    } = require(`@/config/${process.env.VUE_APP_PROJECT}/todo`)
    import { Icon } from 'vant'
    export default {
        name: 'TodoItem',
        components: {
            [Icon.name]: Icon,
        },
        props: {
            data: {
                type: Array,
                default: () => [],
            },
        },
        methods: {
            getStatusText(item) {
                return getStatusText(item)
            },
            getStatusClass(item) {
                return getStatusClass(item)
            },
            handleClick(item) {
                this.$emit('handleClick', item)
            },
        },
    }
</script>

<style lang="scss">
.todo-list-page-list {
  padding: 0 10px;
  background: #fff;

  .todo-list-item {
    position: relative;
    padding: 15px 10px;
    p {
      font-size: 15px;
      font-weight: bold;
      color: #000;
    }
    .todo-list-sub-info {
      padding-left: 2px;
      margin-top: 10px;
      color: rgb(89, 89, 89);
    }
    .todo-list-item-footer {
      margin-top: 10px;
      span {
        display: inline-block;
        padding: 2px 5px;
        border-radius: 3px;
        margin-right: 5px;
      }
      .success {
        border: 2px solid #02b38a;
        color: #02b38a;
      }
      .warning {
        border: 2px solid #ffa033;
        color: #ffa033;
      }
      .danger {
        border: 2px solid #F9435A;
        color: #F9435A;
      }
      .primary {
        border: 2px solid #006BFF;
        color: #006BFF;
      }
    }
    .todo-list-item-btn {
      position: absolute;
      display: inline-block;
      right: 20px;
      bottom: 17px;
      font-size: 14px;
      font-weight: bold;
      color: #02b38a;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      .van-icon-arrow {
        margin-left: 3px;
      }
    }
  }
  .todo-list-item:not(:last-of-type) {
    border-bottom: 1px dashed #cccccc;
  }
}
</style>
